<template>
  <div>
    <div :ref="endpoints[0].ref" class="container">
      <TextArea
        class="child"
        :textTitle="endpointName"
        :textLinesArray="endpointDesc"
      ></TextArea>
      <EndpointCard
        class="child"
        cardTitle="ENDPOINTS"
        :endpoints="endpoints"
      />
    </div>
    <div :ref="endpoints[1].ref" class="container">
      <Attribute
        class="child"
        :attributes="attributes"
        :endpoint="responseTitle"
      />
      <ResponseCard
        class="child"
        :response="response"
        :cardTitle="responseCodeTitle"
      />
    </div>
    <div :ref="endpoints[2].ref" class="container">
      <div class="child">
        <TextArea :textTitle="postTitle" :textLinesArray="postDesc"></TextArea>
        <div>
          <Attribute
            :attributes="postAttributes"
            endpoint="ExternalMaterialDTO"
          />
        </div>
      </div>
      <div class="child">
        <PostExample
          :postExample="postExample"
          cardTitle="POST /api/v3.0/purchaseinvoices/items"
        />
        <ResponseCard
          class="mt-5"
          :response="postResponse"
          cardTitle="RESPONSE."
        />
      </div>
    </div>
    <div :ref="endpoints[3].ref" class="container">
      <div class="child">
        <div>
          <Attribute
            :attributes="getFileResponseExampleAttributes"
            endpoint="FileDataDTO"
          />
        </div>
      </div>
      <div class="child">
        <ResponseCard
          class="mt-5"
          :response="getFileResponseExample"
          cardTitle="File response"
        />
      </div>
    </div>
  </div>
</template>

<style scoped>
.postCard {
  max-height: 600px;
}

.container {
  display: flex;
  flex-flow: row wrap;
  padding-left: 10rem;
  padding-right: 10rem;
}

.child {
  min-width: 40%;
  max-width: 45%;
  flex-grow: 1;
  flex-shrink: 1;
}

@media screen and (max-width: 500px) {
  .container {
    flex-flow: column wrap;
    padding-left: 1rem;
    padding-right: 1rem;
  }
}

@media screen and (max-width: 500px) {
  .child {
    max-width: 380px;
    min-width: 300px;
  }
}
</style>

<script>
import EndpointCard from "../../components/content/EndpointCard.vue";
import Attribute from "../../components/request/Attribute.vue";
import TextArea from "../../components/content/TextArea.vue";
import ResponseCard from "../../components/request/ResponseCard.vue";
import PostExample from "../../components/request/PostExample.vue";

export default {
  components: {
    EndpointCard,
    Attribute,
    TextArea,
    ResponseCard,
    PostExample,
  },
  created() {
    this.$root.$on("scrollToEndpoint", (ref) => {
      var element = this.$refs[ref];
      var top = element.offsetTop;

      window.scrollTo(0, top);
    });
  },
  computed: {
    postTitle() {
      return this.$t("purchaseInvoices.postTitle");
    },
    endpointName() {
      return this.$t("purchaseInvoices.endpointTitle");
    },
    postAttributes() {
      return this.$t("purchaseInvoices.postAttributes");
    },
    postDesc() {
      return this.$t("purchaseInvoices.postDesc");
    },
    postExample() {
      return this.$t("purchaseInvoices.postExample");
    },
    postResponse() {
      return this.$t("purchaseInvoices.postResponse");
    },
    filteringTitle() {
      return this.$t("purchaseInvoices.filteringTitle");
    },
    filteringText() {
      return this.$t("purchaseInvoices.filteringText");
    },
    responseTitle() {
      return this.$t("purchaseInvoices.getTitle");
    },
    responseCodeTitle() {
      return this.$t("purchaseInvoices.responseCodeTitle");
    },
    endpointDesc() {
      return this.$t("purchaseInvoices.endpointDesc");
    },
    endpoints() {
      return this.$t("purchaseInvoices.controllerEndpoints");
    },
    response() {
      return this.$t("purchaseInvoices.getResponse");
    },
    attributes() {
      return this.$t("purchaseInvoices.getAttributes");
    },
    getFileResponseExample() {
      return this.$t("files.fileResponseExample")
    },
    getFileResponseExampleAttributes() {
      return this.$t("files.fileResponseExampleAttributes")
    }
  },
};
</script>